import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import apiClient from '../../apiClient';
import {
    Button,
    Checkbox,
    TextField,
    FormControlLabel,
    Box,
    Stack,
    Divider,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from '@mui/material';
import { containsAllRequiredFields } from '../../components/helper';
import { SelectAllFromTable } from '../universal/Axios';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { observer } from "mobx-react"
import { getStore } from '../../Store'
const store = getStore();


const CreateHeatMap = observer(() => {
    const { push } = useHistory();
    const [heatMap, setHeatMap] = useState({});
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const fileNames = store.networkRuns
    const [fileName, setFileName] = React.useState('');
    const [hideZeroes, setHideZeroes] = React.useState(false);
    const [exploratory, setExploratory] = React.useState(false);
    const [combineChannels, setCombineChannels] = React.useState(false);

    const changeHideZeroes = (event) => {
        setHideZeroes(event.target.checked)
    }

    const changeExploratory = (event) => {
        setExploratory(event.target.checked)
    }

    const changeCombineChannels = (event) => {
        setCombineChannels(event.target.checked)
    }


    useEffect(() => {
        SelectAllFromTable("network_run", store.updateNetworkRuns)
    }, []);

    const changeFileName = (event) => {
        setFileName(event.target.value);
        setHeatMapFields({ key: "file_name", value: event.target.value })
    };

    const requiredFields = [
        "file_name",
    ];

    const validateForm = () => {
        const enableSubmitButton = containsAllRequiredFields({ requiredFields, object: heatMap })
        setSubmitButtonDisabled(!enableSubmitButton)
    }

    const setHeatMapFields = ({ key, value }) => {
        if (typeof value === 'string') {
            value = value.replaceAll("'", "’")
        }
        heatMap[key] = value;
        setHeatMap(heatMap)
        validateForm()
    }

    const createHeatMap = (heatMap) => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Generate_Heatmaps",
                "file_name": heatMap.file_name,
                "hide_zeroes": hideZeroes,
                "exploratory": exploratory,
                "combine_channels": combineChannels 
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully created heat map!")
            push('/network-runs')
        }).catch(function(error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Heat Map")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while creating heat map")
                }
            }
        })
    }

    return (
        <Box>
            <Typography variant="h6">Generate Heat Map</Typography>
            <Box sx={{ m: 2 }}>
                <Stack>
                    <FormControl style={{ width: '216px' }}>
                        <InputLabel id="network_run">File Name</InputLabel>
                        <Select
                            id="file_name"
                            label="File Name"
                            labelId="file_name"
                            value={fileName}
                            variant="outlined"
                            onChange={changeFileName}
                        >
                            {fileNames.slice().sort().map(x => <MenuItem value={x.name} style={{ display: "block" }}>{x.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <FormControlLabel
                        label="Hide Zeroes"
                        control={
                            <Checkbox
                                checked={hideZeroes}
                                onChange={changeHideZeroes}
                                label="Hide Zeroes"
                                size="large"
                            />
                        }
                    />
                    <FormControlLabel
                        label="Exploratory"
                        control={
                            <Checkbox
                                checked={exploratory}
                                onChange={changeExploratory}
                                label="Exploratory"
                                size="large"
                            />
                        }
                    />
                </Stack>
                <Stack direction="row" spacing={1}>
                    <FormControlLabel
                        label="Combine Channels"
                        control={
                            <Checkbox
                                checked={combineChannels}
                                onChange={changeCombineChannels}
                                label="Exploratory"
                                size="large"
                            />
                        }
                    />
                </Stack>
            </Box>
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button onClick={() => push('/network-runs')}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => createHeatMap(heatMap)}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
        </Box>
    )
})

export default CreateHeatMap;